import React from "react";

import { Link } from "react-router-dom";

import { PageHeader, Descriptions, Divider, Table, Popconfirm, Button, Alert, Space, Statistic } from "antd";
import {
    DeleteOutlined,
    DownloadOutlined,
    CheckOutlined,
    PlusOutlined,
    EditOutlined,
    RollbackOutlined,
} from "@ant-design/icons";
import Moment from "moment";
import { DATE_FORMAT } from "../../../../core/utils/i18n-js";
import { AmountText } from "../../../../core/components/widget/amountInline";
import StatisticAmount from "../../../../core/components/widget/amountInline/statistic";
import { expandedPurchaseOrderTask } from "../../../../components/job/finance/purchaseOrderTask";

import { LAYOUT_MANAGER_JOB_SHOW } from "../../../manager/navigation";
import { LAYOUT_FINANCE_PURCHASE_ORDER_ASSIGN_TASK } from "../../navigation";

import {
    INVOICE_STATUS_IN_REVIEW,
    INVOICE_STATUS_ACCEPTED,
    INVOICE_STATUS_PAID,
} from "../../../../components/invoice/status/const";

import FormRectification from "../rectification";
import DisplayRectifaction from "../../../../components/purchaseOrder/rectifications";
import AttachmentList from "../../../../components/purchaseOrder/attachment/list";
import InvoiceButton from "../../../../components/invoice/form/button";
import InvoiceList from "./invoices";

const columnsAntd = (props, showRectificationForm) => {
    const { servicesById, loading, removeTaskFromPOVendor, data, actionLoading, allowEdit } = props;

    if (loading) {
        return [];
    }

    return [
        {
            title: "Job",
            dataIndex: "job_id",
            key: "job",
            fixed: "left",
            sorter: (a, b) => {
                return a.job_id > b.job_id;
            },
            render: (job_id, record) => <Link to={LAYOUT_MANAGER_JOB_SHOW(job_id)}>{record?.job_display_id}</Link>,
        },
        {
            title: "E-ID #",
            dataIndex: "job_external_id",
            key: "job",
            fixed: "left",
            sorter: (a, b) => {
                return a.job_external_id > b.job_external_id;
            },
            render: (job, record) => <>{job}</>,
        },
        {
            title: "Finance Date",
            dataIndex: "finance_date",
            key: "j.financeDate",
            sorter: (a, b) => {
                return a.finance_date > b.finance_date;
            },
            render: (finance_date) => {
                if (finance_date) return <>{Moment(finance_date).format(DATE_FORMAT)}</>;
            },
        },
        {
            title: "Receivable Code",
            dataIndex: "job_external_code",
            key: "j.code",
            doctrineKey: "j.code",
        },

        {
            title: "Service",
            dataIndex: "service",
            key: "t.service",
        },
        {
            title: "Amount",
            dataIndex: "amount_value",
            key: "amountValue",
            sorter: (a, b) => {
                return a.amount_value - b.amount_value;
            },
            // eslint-disable-next-line react/display-name
            render: (jsa, record) => <AmountText value={record.amount_value} type={record.amount_type} />,
        },
        {
            title: "Action",
            key: "action",
            render: (text, record) => {
                const task = (data.tasks || []).find((item) => item.id == record.task_id);

                return (
                    <Space>
                        {" "}
                        {allowEdit && !hasRectification(record, task) && (
                            <>
                                <Popconfirm
                                    title="Are you sure?"
                                    onConfirm={() => removeTaskFromPOVendor(data.purchaseOrder.id, record.id)}
                                    okText="Yes"
                                    cancelText="No"
                                    disabled={actionLoading}
                                >
                                    <Button icon={<DeleteOutlined />} size="small">
                                        Remove
                                    </Button>
                                </Popconfirm>

                                <Divider type="vertical" />
                                <Button
                                    icon={<EditOutlined />}
                                    size="small"
                                    onClick={() => showRectificationForm(record.id)}
                                    disabled={actionLoading}
                                >
                                    Rectificate
                                </Button>
                            </>
                        )}
                    </Space>
                );
            },
        },
    ];
};

const hasRectification = (pot, task) => {
    return (task?.payables || []).some((p) => p.rectification);
};

const Content = ({ children, extra }) => {
    return (
        <div className="content">
            {/*<img src="https://icon-library.com/images/translate-icon-png/translate-icon-png-9.jpg" alt="content" width="100px"/>*/}
            <div className="main">{children}</div>
            <div className="extra">{extra}</div>
        </div>
    );
};

const extraContent = (props) => (
    <div
        style={{
            display: "flex",
            width: "max-content",
            justifyContent: "flex-end",
        }}
    >
        <Statistic
            title="Status"
            value={props.data.purchaseOrder.status}
            style={{ marginRight: 32 }}
            valueStyle={{ color: '"#7e807f' }}
        />

        <StatisticAmount
            title="Amount"
            value={props.data.purchaseOrder.amount_value}
            prefix={props.data.purchaseOrder.amount_type}
        />
    </div>
);

/**
 *
 */
export default class Show extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalRectificationVisible: false,
            purchaseOrderTaskId: 0,
        };
    }
    _goBack = () => {
        this.props.history.goBack();
    };

    showRectificationForm = (purchaseOrderTaskId) => {
        this.setState({
            modalRectificationVisible: true,
            purchaseOrderTaskId,
        });
    };

    render() {
        const {
            data,
            vendorsById,
            acceptPurchaseOrder,
            revertPurchaseOrder,
            downloadFile,
            includeRectification,
            deleteRectification,
            actionLoading,
            allowEdit,
        } = this.props;

        const displayRectifaction = (purchaseOrderTask) => {
            const task = (data.tasks || []).find((item) => item.id == purchaseOrderTask.task_id);
            return (
                <DisplayRectifaction
                    purchaseOrderId={data.purchaseOrder.id}
                    task={task}
                    purchaseOrderTask={purchaseOrderTask}
                    allowEdit={allowEdit}
                    includeRectification={includeRectification}
                    deleteRectification={deleteRectification}
                    loading={actionLoading}
                />
            );
        };
        const vendorName = data?.purchaseOrder?.vendor_name;

        const expandedRowClassName = (record, index, indent) => "table-finance-details";

        const expandedRowRender = (record) => {
            const task = (data.tasks || []).find((item) => item.id == record.task_id);

            if ((task.payables || []).length > 0) {
                return (
                    <>
                        {expandedPurchaseOrderTask(record, task)}
                        {hasRectification(record, task) && displayRectifaction(record)}
                    </>
                );
            }

            if (hasRectification(record, task)) {
                return displayRectifaction(record);
            }

            return null;
        };

        const addInvoice = (form) => this.props.addInvoice(data.purchaseOrder.id, form);
        const onConfirmInvoice = (id) => this.props.confirmInvoice(data.purchaseOrder.id, id);
        const onRevertInvoice = (id) => this.props.revertInvoice(data.purchaseOrder.id, id);
        const onRemoveInvoice = (id) => this.props.removeInvoice(data.purchaseOrder.id, id);

        const purchaseOrderActions = (props) => {
            if (props.data.purchaseOrder?.status === "In Review") {
                return [
                    <Button
                        key="accept"
                        type="primary"
                        size="small"
                        disabled={actionLoading || !allowEdit}
                        onClick={() => acceptPurchaseOrder(data.purchaseOrder.id)}
                    >
                        <CheckOutlined />
                        <Divider type="vertical" />
                        Mark as accepted
                    </Button>,
                ];
            }

            if (props.data.purchaseOrder?.status === "Accepted") {
                return [
                    <Button
                        key="revert"
                        disabled={!this.props.isOwner}
                        size="small"
                        icon={<RollbackOutlined />}
                        onClick={() => revertPurchaseOrder(data.purchaseOrder.id)}
                    >
                        Revert
                    </Button>,
                    <InvoiceButton
                        key="invoice"
                        buttonLabel="Add invoice"
                        onUpload={addInvoice}
                        amountValue={props.data.purchaseOrder.amount_value}
                        amountType={props.data.purchaseOrder.amount_type}
                        defaultText={`Generated from ${data.purchaseOrder.display_id}`}
                        fileRequired={false}
                    />,
                ];
            }

            return [];
        };

        return (
            <>
                <div className="site-page-header-ghost-wrapper">
                    <PageHeader
                        ghost={false}
                        className="site-page-header"
                        onBack={this._goBack}
                        title={`${data.purchaseOrder?.display_id} / ${data.purchaseOrder.code}`}
                        subTitle="Purchase Order"
                        extra={purchaseOrderActions(this.props)}
                    >
                        <Content extra={extraContent(this.props)}>
                            <Descriptions size="medium" column={2}>
                                <Descriptions.Item label="Vendor">{data.purchaseOrder.vendor_name}</Descriptions.Item>
                                <Descriptions.Item label="Date">
                                    {" "}
                                    {Moment(data.purchaseOrder.date).format(DATE_FORMAT)}{" "}
                                </Descriptions.Item>
                                <Descriptions.Item label="Notes"> {data.purchaseOrder.notes} </Descriptions.Item>
                            </Descriptions>
                        </Content>
                    </PageHeader>
                </div>

                <br />
                <InvoiceList
                    invoices={data.purchaseOrder?.invoices}
                    onDownloadInvoice={this.props.downloadInvoice}
                    onConfirmInvoice={onConfirmInvoice}
                    onRevertInvoice={onRevertInvoice}
                    onRemoveInvoice={onRemoveInvoice}
                    actionLoading={this.props.actionLoading}
                />
                <br />

                <PageHeader ghost={false}>
                    <Space>
                        <Button
                            type="default"
                            onClick={() =>
                                downloadFile(
                                    data.purchaseOrder.id,
                                    `PO-${data.purchaseOrder.id}_${data.purchaseOrder.vendor_name}.xlsx`
                                )
                            }
                            size="small"
                            loading={actionLoading}
                        >
                            <DownloadOutlined />
                            <Divider type="vertical" />
                            Download PO
                        </Button>
                        {allowEdit && (
                            <Link
                                to={LAYOUT_FINANCE_PURCHASE_ORDER_ASSIGN_TASK(
                                    data.purchaseOrder.id,
                                    data.purchaseOrder.code,
                                    data.purchaseOrder.vendor_id
                                )}
                            >
                                <Button type="default" size="small">
                                    <PlusOutlined />
                                    <Divider type="vertical" />
                                    Add Task
                                </Button>
                            </Link>
                        )}
                    </Space>
                    <br />

                    <br />

                    <Table
                        bordered={true}
                        size="small"
                        croll={{ x: 1300 }}
                        rowKey={(row) => row.id}
                        dataSource={data.purchaseOrder.purchase_order_tasks}
                        columns={columnsAntd(this.props, this.showRectificationForm)}
                        expandable={{
                            expandedRowClassName,
                            expandedRowRender,
                            rowExpandable: (record) => true,
                        }}
                    />
                </PageHeader>

                {this.state.modalRectificationVisible && (
                    <FormRectification
                        visible={this.state.modalRectificationVisible}
                        handleCancel={() => {
                            this.setState({ modalRectificationVisible: false });
                        }}
                        purchaseOrderId={data.purchaseOrder.id}
                        purchaseOrderTaskId={this.state.purchaseOrderTaskId}
                    />
                )}
            </>
        );
    }
}
